import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';

class ExperiencesTitle extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="ExperiencesTitleContainer">
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="text subtitleFonts">
                From streaming to security, learn how to get the most out of your tech through a 15-minute conversation
                with an expert. It's part of your premium membership.
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (/*state, ownProps*/) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExperiencesTitle);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/ExperiencesTitle/ExperiencesTitle.js